import Notification from 'choerodon-ui/lib/notification';
export default Notification;
